<template>
  <div class="page-wrapper">
    <div class="tableBox">
      <el-table v-loading="isLoading" :data="tableData" border>
        <el-table-column label="主体名称">
          <template slot-scope="scope">
            {{scope.row.fzzhtMemberInfo.principalName}}
          </template>
        </el-table-column>
        <el-table-column label="主体类型" prop="subjectType">
          <template slot-scope="scope">
            {{scope.row.principalTypeStr}}
          </template>
        </el-table-column>
        <el-table-column label="来源">
          <template slot-scope="scope">
            {{scope.row.sourceStr}}
          </template>
        </el-table-column>
        <el-table-column label="被查询次数">
          <template slot-scope="scope">
            {{scope.row.queryCount}}
          </template>
        </el-table-column>
        <el-table-column label="主体介绍概要">
          <template slot-scope="scope">
            {{scope.row.desc || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="证书类型" width="160">
          <template slot-scope="scope">
            <div class="cell-box">
              <div class="cell-item" v-for="(item, index) in scope.row.fzzhtMemberCertificates" :key="index">
                {{item.type}}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="证书编号" width="160">
          <template slot-scope="scope">
            <div class="cell-box">
              <div class="cell-item" v-for="(item, index) in scope.row.fzzhtMemberCertificates" :key="index">
                {{item.showNumber || '无'}}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="入会时间">
          <template slot-scope="scope">
            <div class="cell-box">
              <div class="cell-item" v-for="(item, index) in scope.row.fzzhtMemberCertificates" :key="index">
                {{item.joinDate}}
              </div>
            </div>
          </template>
        </el-table-column>  
        <el-table-column label="操作" width="240">
          <template slot-scope="scope">
            <el-button type="primary" plain size="mini" style="margin: 2px;" @click="$router.push('/certificate/edit?id=' + scope.row.fzzhtMemberInfo.id)">编辑</el-button>
            <el-button type="primary" plain size="mini" style="margin: 2px;" @click="openAddCertificate(scope.row)">增加证书</el-button>
            <el-button type="primary" plain size="mini" style="margin: 2px;" @click="openCertificateShow(scope.row)">查询显示证书</el-button>
            <el-button type="primary" plain size="mini" style="margin: 2px;" @click="$router.push('/certificate/detail?id=' + scope.row.fzzhtMemberInfo.id)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageBox">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pagination.current"
        :page-size.sync="pagination.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        background
      >
      </el-pagination>
    </div>

    <!-- 显示证书选项 -->
    <el-dialog :title="'（' + certificateShowData.fzzhtMemberInfo.principalName + '）显示证书'" :visible.sync="certificateShow" width="800px" center>
      <div class="dia-cer-list" v-if="memberCertificateList && memberCertificateList.length > 0">
        <div class="show-item" v-for="item in memberCertificateList" :key="item.id">
          <span class="col" style="min-width: 260px">{{ item.type }}： 已生成</span>
          <span class="col" style="min-width: 180px">会员级别：{{ item.level }}</span>
          <span class="col">前台是否可查询：<el-checkbox v-model="item.queryChecked"></el-checkbox></span>
        </div>
      </div>
      <div v-else style="text-align: center">
        暂无证书
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmEidtCertificate">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 增加证书 -->
    <el-dialog :title="'（'+ addCertificateData.fzzhtMemberInfo.principalName + '）增加证书'" :visible.sync="addCertificateVisible" width="1000px" center>
      <div class="dia-cer-list">
        <h3>已生成的：</h3>
        <template v-if="existedCertificateList && existedCertificateList.length > 0">
          <div class="item" style="border-bottom: 1px dashed #ccc; padding-bottom: 8px; margin-bottom: 8px;" v-for="item in existedCertificateList" :key="item.id">
            <span class="col">{{item.type}}： 已生成</span>
            <span class="col">证书类型显示文字：{{item.displayName || '-'}}</span>
            <span class="col">会员级别：{{item.level || '-'}}</span>
            <span class="col">会员级别显示文字：{{item.displayText || '-'}}</span>
            <span class="col">类目等级：{{item.bizLevel || '无'}}</span>
            <span class="col">类目类型：{{item.bizType || '无'}}</span>
            <span class="col">入会时间：{{item.joinDate || '-'}}</span>
            <span class="col">前台是否可查询：{{item.status == 1 ? '可查询' : '不可查询'}}</span>
          </div>
        </template>
        <div v-else> 暂无已生成的证书 </div>
        
        <h3>增加证书</h3>
        <el-form v-if="addCertificateList.length > 0">
          <div class="cer-type-list" v-for="(item) in addCertificateList" :key="item.categoryId">
            <el-form-item label-width="0">
              <div class="item">
                <span class="col">
                  {{item.categoryName}}：
                  <el-checkbox v-model="item.checked"></el-checkbox>
                </span>
                <span class="col">
                  证书类型显示文字：{{item.children && item.children[0] && item.children[0].displayName || '-'}}
                </span>
                <span class="col">会员级别：
                  <el-select v-model="item.levelId" placeholder="请选择" size="small">
                    <el-option
                      v-for="ele in item.children"
                      :key="ele.categoryId"
                      :label="ele.categoryName"
                      :value="ele.categoryId"
                    ></el-option>
                  </el-select>
                </span>
                <span class="col">会员级别显示文字：
                  <el-select v-model="item.levelId" placeholder="请选择" size="small">
                    <el-option
                      v-for="ele in item.children"
                      :key="ele.categoryId"
                      :label="ele.displayText"
                      :value="ele.categoryId"
                    ></el-option>
                  </el-select>
                </span>
                <span class="col">类目等级：
                  <el-select v-model="item.bizLevel_id_name" placeholder="请选择" size="small">
                    <el-option
                      v-for="ele in businessGradeData"
                      :key="ele.categoryId"
                      :label="ele.categoryName"
                      :value="ele.categoryId + ',' + ele.categoryName"
                    >
                    </el-option>
                  </el-select>
                </span>
                <span class="col">类目类型：
                  <el-select v-model="item.bizType_id_name" placeholder="请选择" size="small">
                    <el-option
                      v-for="ele in businessTypeData"
                      :key="ele.categoryId"
                      :label="ele.categoryName"
                      :value="ele.categoryId + ',' + ele.categoryName"
                    >
                    </el-option>
                  </el-select>
                </span>
                <span class="col">入会时间：
                  <el-date-picker
                    v-model="item.date"
                    size="small"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </span>
                <span class="col">前台是否可查询：<el-checkbox v-model="item.queryChecked"></el-checkbox></span>
              </div>
            </el-form-item>
          </div>
        </el-form>
        <div v-else>
          暂无可增加的证书
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="previewAddCertificate">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 预览 -->
  <el-dialog title="预览" :visible.sync="previewVisible" width="1000px" center>
    <div class="preview-detail">
      <h3>增加证书：</h3>
      <div class="certificate-type-item" v-for="item in addMemberCertificates" :key="item.id">
        <div class="info">
          {{ item.type }}：已生成  &nbsp;&nbsp;&nbsp;
          证书编号：{{ item.number || '-' }} &nbsp;&nbsp;
          会员级别：{{ item.level }} &nbsp;&nbsp;&nbsp;
          入会时间：{{ item.joinDate }} &nbsp;&nbsp;&nbsp;
          前台是否可查询：{{ item.status === 1 ? '可查询' : '不可查询' }}
        </div>
        <div class="img">
          <canvas style="width: 800px; display:block;" :id="'canvas-' + item.levelId + '-' + item.typeId"></canvas>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirmAddCertificate">提交</el-button>
    </span>
  </el-dialog>
  </div>
</template>

<script>
import { utils } from "@/common/common.js";
import { request, api } from '@/common/request_course.js';
import { buildThumborUrl } from "@/common/tool.js";
import { DEFAULT_CERTIFICATE_NAME, YSWL_CERTIFICATE_NAME } from './util/constant'
export default {
  name: "certificate-list",
  data() {
    return {
      isLoading: false,
      pagination: {
        current: 1,
        size: 10,
        total: 0,
      },
      // 表格数据
      tableData: [],

      // 显示证书选项 //
      certificateShow: false,
      // 当前操作数据
      certificateShowData: {
        fzzhtMemberInfo: {},
        fzzhtMemberCertificates: [],
      },
      // 显示的针证书列表
      memberCertificateList: [],

      // 新增证书 //
      addCertificateVisible: false,
      // 当前操作数据
      addCertificateData: {
        fzzhtMemberInfo: {},
        fzzhtMemberCertificates: [],
      },
      // 所有证书类型列表
      certificateTypesData: [],

      // 所有类目/业务等级数据
      businessGradeData: [],
      // 所有类目/业务类型数据
      businessTypeData: [],

      // 已存在证书
      existedCertificateList: [],
      // 新增加证书
      addCertificateList: [],
      previewVisible: false,
      addMemberCertificates: [],


    };
  },
  computed: {
    IMG_PREV() {
      return api.imgPrev;
    },
    adminId() {
      return utils.getAdminId();
    },
    token() {
      return utils.getToken();
    },
  },
  watch: {},
  components: {},
  created() {
    this.getTableList()
  },
  methods: {
    getTableList() {
      this.isLoading = true
      request({
        url: api.baseUrl + "/certificate/fzzht-member-info/pageList",
        method: "get",
        params: {
          current: this.pagination.current,
          size: this.pagination.size,
        }
      }).then(res => {
        this.isLoading = false
        console.log(res);
        if (res.erroyCode == 200) {
          this.tableData = res.data.records.map(item => {
            let number
            let numberObj = item.fzzhtMemberCertificates.find(ele => ele.number)
            if (numberObj) number = numberObj.number
            let desc = this.replaceHtmlTag(item.fzzhtMemberInfo.desc)
            if (desc && desc.length > 50 ) {
              desc = desc.substring(0, 50) + '...'
            }
            return ({
              ...item,
              fzzhtMemberCertificates: item.fzzhtMemberCertificates.map(ele => {
                if (ele.type === YSWL_CERTIFICATE_NAME) {
                  return {
                    ...ele,
                    showNumber: number
                  }
                }
                return {
                  ...ele,
                  showNumber: ele.number
                }
              }),
              desc
            })
          })
          this.pagination.total = res.data.total
        }
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
    handleSizeChange(size) {
      console.log(size)
      this.pagination.current = 1
      this.pagination.size = size
      this.getTableList()
    },
    handleCurrentChange(current) {
      console.log(current)
      this.pagination.current = current
      this.getTableList()
    },

    // 打开显示证书选项
    openCertificateShow(row) {
      this.certificateShowData = row
      this.memberCertificateList = row.fzzhtMemberCertificates.map(item => {
        return ({
          ...item,
          queryChecked: item.status == 1 ? true : false
        })
      })
      this.certificateShow = true
    },
    // 确认编辑证书
    confirmEidtCertificate() {
      let fzzhtMemberCertificates = this.memberCertificateList.map(item => {
        return ({
          displayName: item.displayName,
          displayText: item.displayText,
          bizLevel: item.bizLevel,
          bizLevelId: item.bizLevelId,
          bizType: item.bizType,
          bizTypeId: item.bizTypeId,
          lastUpdateBy: this.adminId,
          joinDate: item.joinDate,
          level: item.level,
          levelId: item.levelId,
          member: this.certificateShowData.fzzhtMemberInfo.principalName,
          memberId: this.certificateShowData.fzzhtMemberInfo.id,
          number: item.number || undefined,
          status: item.queryChecked ? 1 : 0,
          type: item.type,
          typeId: item.typeId,
          id: item.id,
        })
      })
    
      console.log('fzzhtMemberCertificates', fzzhtMemberCertificates)
      request({
        url: api.baseUrl + "/certificate/fzzht-member-certificate/update",
        method: "post",
        data: fzzhtMemberCertificates
      }).then(res => {
        console.log(res);
        if (res.erroyCode == 200) {
          this.$message.success('操作成功')
          this.certificateShow = false
          this.getTableList()
        } else {
          this.$message.error(res.errorMsg || "网络错误");
        }
      }).catch((err) => {
        console.log(err);
      })
    },

    // 打开增加证书
    openAddCertificate(row) {
      this.addCertificateData = row
      // 已存在证书
      this.existedCertificateList = row.fzzhtMemberCertificates
      console.log(this.existedCertificateList)
      // 新增加证书
      this.getCerTypeList()
      this.getBusinessGradeList()
      this.getBusinessTypeList()

      this.addCertificateVisible = true
    },
    // 获取证书类型列表
    getCerTypeList() {
      request({
        url: api.baseUrl + "/certificate/yijiajia-data-category/listTree",
        method: "get",
        params: {
          categoryType: '20203'
        }
      }).then(res => {
        console.log(res);
        if (res.erroyCode == 200) {
          this.certificateTypesData = res.data.map(item => {
            return ({
              ...item,
              children: item.children.map(ele => ({
                ...ele,
                showUrl: buildThumborUrl(ele.certificateImage, {width: 1000})
              }))
            })
          })
          this.addCertificateList = this.certificateTypesData
            .filter(item => this.existedCertificateList.every(ele => ele.typeId != item.categoryId))
            .map(item => {
              return ({
                ...item,
                checked: false,
                levelId: '',
                date: '',
                queryChecked: false,
                bizLevel_id_name: '无,无',
                bizType_id_name: '无,无',
              })
            }) 
          console.log(this.addCertificateList)
        } else {
          this.$message.error(res.errorMsg || "网络错误");
        }
      }).catch((err) => {
        console.log(err);
      })
    },

    // 获取类目/业务等级
    getBusinessGradeList() {
      request({
        url: api.baseUrl + "/certificate/yijiajia-data-category/listTree",
        method: "get",
        params: {
          categoryType: '20204'
        }
      }).then(res => {
        console.log(res);
        if (res.erroyCode == 200) {
          this.businessGradeData = [
            {
              categoryId: '无',
              categoryName: '无',
              categoryStatus: "y",
              categoryType: 20204,
              children: [],
              parentId: 0
            }].concat(res.data)
        } else {
          this.$message.error(res.errorMsg || "网络错误");
        }
      }).catch((err) => {
        console.log(err);
      })
    },
    // 获取类目/业务类型
    getBusinessTypeList() {
      request({
        url: api.baseUrl + "/certificate/yijiajia-data-category/listTree",
        method: "get",
        params: {
          categoryType: '20205'
        }
      }).then(res => {
        console.log(res);
        if (res.erroyCode == 200) {
          this.businessTypeData = [
            {
              categoryId: '无',
              categoryName: '无',
              categoryStatus: "y",
              categoryType: 20205,
              children: [],
              parentId: 0
            }].concat(res.data)
        } else {
          this.$message.error(res.errorMsg || "网络错误");
        }
      }).catch((err) => {
        console.log(err);
      })
    },
    
    // 获取证书编号
    getCertificateNumber() {
      return request({
        url: api.baseUrl + "/certificate/fzzht-member-certificate/getCertificateNumber",
        method: "get",
      })
    },
    // 确认增加证书 - 预览
    async previewAddCertificate() {
      let selectedCertificateTypes = this.addCertificateList
        .filter(item => item.checked)
      if (selectedCertificateTypes.length == 0) {
        return this.addCertificateVisible = false
      }

      if (selectedCertificateTypes.some(item => !item.levelId || !item.date)) {
        return this.$message.error('已勾选的证书， 请选择会员级别和入会时间')
      }

      console.log(selectedCertificateTypes);

      this.previewVisible = true

      let cerNumberRes
      try {
        cerNumberRes = await this.getCertificateNumber()
      } catch (error) {
        console.log('error', error)
      }

      let fzzhtNumber 
      let fzzhtNumberObj = this.existedCertificateList.find(item => !!item.number)
      if (fzzhtNumberObj) fzzhtNumber = fzzhtNumberObj.number

      this.addMemberCertificates = await Promise.all(selectedCertificateTypes.map(async item => {
          let cerNumber
          if (item.categoryName == DEFAULT_CERTIFICATE_NAME || item.categoryName == YSWL_CERTIFICATE_NAME) {
            if (fzzhtNumber) {
              cerNumber = fzzhtNumber
            } else {
              cerNumber = cerNumberRes.data
            }
          }

          let bizLevelArr = item.bizLevel_id_name == '无,无' ? [] : item.bizLevel_id_name.split(',')
          let bizTypeArr = item.bizType_id_name == '无,无' ? [] : item.bizType_id_name.split(',')
          
          return ({
            createBy: this.adminId,
            joinDate: item.date,
            level: item.children.find(c => c.categoryId === item.levelId).categoryName,
            levelId: item.levelId,
            member: this.addCertificateData.fzzhtMemberInfo.principalName,
            memberId: this.addCertificateData.fzzhtMemberInfo.id,
            number: cerNumber || undefined,
            status: item.queryChecked ? 1 : 0,
            type: item.categoryName,
            typeId: item.categoryId,
            showUrl: buildThumborUrl(item.children.find(ele => ele.categoryId === item.levelId).certificateImage, {width: 1263, height: 893}),
            displayName: item.children.find(c => c.categoryId === item.levelId).displayName,
            displayText: item.children.find(c => c.categoryId === item.levelId).displayText,
            bizLevelId: bizLevelArr[0],
            bizLevel: bizLevelArr[1],
            bizTypeId: bizTypeArr[0],
            bizType: bizTypeArr[1],
          })
        })
      )
      console.log('addMemberCertificates', this.addMemberCertificates)

      this.$nextTick(() => {
        this.addMemberCertificates.forEach(item => {
          let canvas = document.getElementById('canvas-'  + item.levelId + '-' + item.typeId);
          canvas.width = 1263; 
          canvas.height = 893;
          let context = canvas.getContext('2d');
          let image = new Image()
          let imgUrl = item.showUrl
          if (imgUrl) {
            image.src = imgUrl
            console.log('imgUrl', imgUrl)
            image.onload = function(){
              context.drawImage(image, 0, 0, 1263, 893)
              let companyTitle = item.member || ''
              let titleLength = companyTitle.length;
              let fontSize = 40;
              if (titleLength > 16) fontSize = 32
              if (titleLength > 24) fontSize = 24
              if (titleLength > 32) fontSize = 20
              context.font = "bold " + fontSize + "px KaiTi,STKaiti";
              context.textAlign="center";
              context.fillStyle="#000000";
              context.fillText(companyTitle, 442, 180);

              if (item.number) {
                context.font = "20px SimSun";
                context.textAlign="start";
                context.fillStyle="#000000";
                context.fillText('No:' + item.number, 82, 64);
              }

              if (item.displayName) {
                context.font = "bold 68px SimSun";
                context.textAlign="center";
                context.fillStyle="#e50021";
                context.fillText(item.displayName, 442, 390);
              }

              if (item.displayText) {
                context.font = "bold 68px SimSun";
                context.textAlign="center";
                context.fillStyle="#e50021";
                context.fillText(item.displayText, 442, 478);
              }

              let level_type = ''
              if (item.bizLevel) {
                level_type += item.bizLevel + ':'
              }
              if (item.bizType) {
                level_type += item.bizType
              }

              if (level_type) {
                context.font = "bold 28px SimSun";
                context.textAlign="start";
                context.fillStyle="#e50021";
                context.fillText(level_type, 925, 150);
              }
            }
          } else {
            context.font = "36px KaiTi,STKaiti";
            context.textAlign="center";
            context.fillStyle="#000000";
            context.fillText('暂无证书模板， 无法生成预览图', 632, 446);
          }
          
        })
      })

      
    },
    // 确认增加证书 - 提交
    confirmAddCertificate() {
      let fzzhtMemberCertificates = this.addMemberCertificates.map(item => {
        let r = {...item}
        delete r.showUrl
        if (r.type !== DEFAULT_CERTIFICATE_NAME) {
          delete r.number
        } 
        return r
      })
      request({
        url: api.baseUrl + "/certificate/fzzht-member-certificate/save",
        method: "post",
        data: fzzhtMemberCertificates
      }).then(res => {
        console.log(res);
        if (res.erroyCode == 200) {
          this.previewVisible = false
          this.addCertificateVisible = false
          this.addMemberCertificates = []
          this.getTableList()
        } else {
          this.$message.error(res.errorMsg || "网络错误");
        }
      }).catch((err) => {
        console.log(err);
      })
    },
    // 提取html中的纯文本
    replaceHtmlTag(str) {
      return str.replace(/<.*?>/gi, '')
    },
  },
};
</script>

<style scoped lang="scss">
.page-wrapper {
  background: #fff;
  padding: 16px;
  margin: 10px;
  .cell-box {
    margin: 0;
    .cell-item {
      height: 40px;
      border-bottom: 1px solid #eee;
      display: flex;
      justify-content: center;
      align-items: center;
      &:last-child {
        border-bottom: none;
      }
    }
  }
  .dia-cer-list {
    min-height: 200px;
    .show-item {
      display: flex;
      margin-bottom: 10px;
      padding: 10px 0;
      border-bottom: 1px solid #eee;
    }
    .cer-type-list {
      .item {
        padding-bottom: 22px;
        border-bottom: 1px dashed #ccc;
      }
    }
    
    .col {
      width: 48%;
      display: inline-block;
    }

  }

}
</style>



// WEBPACK FOOTER //
// src/pages/certificate/list.vue